import { get, post, put } from "./apiClient";

export default {
  async get(facilityId) {
    return await get(`facility/${encodeURIComponent(facilityId)}/roomTemplate`);
  },

  async create(facilityId, roomTemplate) {
    return await post(
      `facility/${encodeURIComponent(facilityId)}/roomTemplate`,
      roomTemplate
    );
  },

  async edit(facilityId, roomTemplate) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/roomTemplate`,
      roomTemplate
    );
  }
};
